module.exports = __webpack_public_path__ + "static/media/Odisee.c6464a78.png";